import type {
  AgreementListData,
  SubmitAgreementParams,
  AgreementItem,
} from '@/api/convergeAgreement/types';
import type { ConvergeAgreementItem } from './types';

/**
 * 合并协议列表后展示
 * @param data 协议列表数据
 * @param bioAuthPriority 活体协议是否优先展示
 * @returns 格式化后的协议列表
 */
export function formatAgreementList(
  data: AgreementListData,
  bioAuthPriority = false,
): ConvergeAgreementItem[] {
  const agreementList: ConvergeAgreementItem[] = [];

  if (data.registerAgreement?.show || data.userRegisterAgreement?.show) {
    agreementList.push({
      name: '用户协议及隐私政策',
      list: [
        ...(data.registerAgreement?.list || []),
        ...(data.userRegisterAgreement?.list || []),
      ],
    });
  }
  if (data.bioAuthAgreement?.show) {
    agreementList.push({
      name: '人脸识别服务协议',
      list: [
        ...(data.bioAuthAgreement?.list || []),
      ],
    });
  }

  /** 若活体协议优先展示，则将活体协议列表反转 */
  if (bioAuthPriority) {
    agreementList.reverse();
  }

  if (data.creditAgreement?.show) {
    agreementList.push({
      name: '综合服务协议',
      list: [
        ...(data.creditAgreement?.list || []),
      ],
    });
  }
  /** 征信协议，应合规的要求，需要平铺展示 */
  if (data.creditRouteChannelAgreement?.show) {
    const creditAgreements = data.creditRouteChannelAgreement.list || [];

    agreementList.push(...creditAgreements.map((agreement: AgreementItem) => ({
      name: agreement.agreementName.replace(/[《》]/g, '') || '',
      list: [agreement],
    })));
  }
  return agreementList;
}

/**
 * 构建提交协议的参数
 * @param data 协议列表数据
 * @param transactionId 活体事务ID
 * @returns 提交协议的参数
 */
export function buildSubmitAgreementParams(
  data: AgreementListData,
  transactionId = '',
): SubmitAgreementParams {
  const creditRouteAgreementList = data.creditRouteChannelAgreement?.list || [];

  return {
    // 资产注册协议ID列表
    registerAgreementIds: data.registerAgreement?.list?.map((item) => item.id || '') || [],
    // 平台注册协议ID列表
    userRegisterAgreementIds: data.userRegisterAgreement?.list?.map((item) => item.id || '') || [],
    // 活体协议
    bioAgreement: {
      transactionId,
      version: data.bioAuthAgreement?.list?.[0]?.version || '',
    },
    // 征信协议
    creditRouteChannelSign: {
      creditChannel: data.creditRouteChannelAgreement?.creditChannel || '',
      agreementIds: creditRouteAgreementList.map((item) => item.id || ''),
    },
  };
}
